import {loadAllLookupPages} from "../../hooks/useInventoryLookups";
import { useEffect, useState } from "react";
import type { KeyValue } from "../../models/KeyValue";
import { CustomerService } from "../../services/CustomerService";
import { ProductService } from "../../services/ProductService";

export interface OrderDTO {
  Error: string;
  Customers: KeyValue[];
  Products: KeyValue[];
}

export function useOrder(): OrderDTO {
  const [state, setState] = useState<OrderDTO>({ Error: "", Customers: [], Products: [] });
  useEffect(() => {
    void Promise.all([
      loadAllLookupPages(CustomerService().GetActivePartial),
      loadAllLookupPages(ProductService().GetActivePartial),
    ]).then(([customers, products]) =>
      setState({ Error: "", Customers: customers, Products: products }),
    ).catch(()=>setState(current=>({...current,Error:"Could not load transaction options. Reload this page to try again."})));
  }, []);
  return state;
}
